import './styles.css';
import { InputNumber } from 'primereact/inputnumber';

function InputMoney({
  htmlFor,
  id,
  name,
  className = "",
  label,
  onChange,
  minFractionDigits,
  maxFractionDigits,
  onFocus,
  mode,
  locale = "pt-BR",
  onBlur,
  value,
  required = false,
  placeholder,
  disabled = false,
  error,
  touched,
  helpText,
  colSpan,
  labelChildren,
  autoComplete = "off",
  compact = false,
}) {
  const hasError = touched && !!error;

  const inputEl = (
    <InputNumber
      id={id}
      name={name}
      onValueChange={onChange}
      minFractionDigits={minFractionDigits}
      maxFractionDigits={maxFractionDigits}
      onBlur={onBlur}
      mode={mode}
      locale={locale}
      onFocus={onFocus}
      value={value}
      placeholder={placeholder}
      autoComplete={autoComplete}
      disabled={disabled}
      className="w-full"
      inputClassName={compact ? `
          !w-full
          !h-7
          !px-1.5
          !py-0
          !text-[11px]
          !leading-none
          !rounded
          transition-all
          duration-150
          outline-none
          ${disabled && "bg-muted cursor-not-allowed"}

          ${hasError
            ? "border border-destructive focus:ring-1 focus:ring-destructive/20"
            : "border border-input focus:border-primary focus:ring-1 focus:ring-primary/20"
          }

          ${className}
        ` : `
          w-full
          h-9
          px-3
          text-sm
          transition-all
          duration-150
          outline-none
          rounded-md
          ${disabled && "bg-muted cursor-not-allowed"}

          ${hasError
            ? "border border-destructive focus:ring-2 focus:ring-destructive/20"
            : "border border-input focus:border-primary focus:ring-2 focus:ring-primary/15"
          }

          ${className}
        `}
    />
  );

  if (compact) return inputEl;

  return (
    <div className={`flex flex-col gap-1.5 md:col-span-${colSpan}`}>
      {(label || labelChildren || required) && (
        <label
          htmlFor={htmlFor || id}
          className={`text-sm font-medium ${hasError ? "text-destructive" : "text-foreground/80"}`}>
          {label}
          {labelChildren}
          {required && <span className="text-destructive ml-1">*</span>}
        </label>
      )}

      {/* Input */}
      {inputEl}

      {/* Mensagem abaixo */}
      {hasError ? (
        <span className="text-xs text-destructive">{error}</span>
      ) : helpText ? (
        <span className="text-xs text-muted-foreground">{helpText}</span>
      ) : null}
    </div>
  );
}

export default InputMoney;
